<template>
	<div>
		<div id="app">
			<div class="public-header " v-if="!isMobile">
				<div class="content-bd">
					<div class="logo-bd f-l" @click="goHome" style="cursor: pointer;"><img src="./assets/images/logo2.png"></div>
					<div style="float:right;margin-top: 10px;">
						<!-- <div class="language-bd f-r">
					<ul>
						<li class="f-l" v-for="language in languageList" :class="{on:language.key==currentLanguage}" @click="setLanguage(language.key)">{{language.name}}</li>
					
						<div class="clearfix"></div>
					</ul>
				</div> -->
						<div style="float:right;margin-right:18px">
							<select v-model="currentLanguage" @change="setLanguage()">
								<option :value="language.key" v-for="language in languageList">{{ language.name }}</option>
							</select>
						</div>
						<div class="nav-c">

							<router-link v-for="routerC in router" :to="routerC.link + '/' + currentLanguage"
								@click.native='getLink(routerC.link)'>{{ routerC.name }}</router-link>


							<div class="clearfix"></div>
						</div>
					</div>
					<div class="clearfix"></div>
				</div>
			</div>
			<template v-else>

			</template>
			<template v-if="showRouter">
				<router-view />
			</template>
		</div>
	</div>
</template>

<script>
import Header from './components/mobile/header.vue'
export default {
	name: 'App',
	components: {},
	data() {
		return {
			routers: [
				{ language: "zh", router: [{ link: '', name: '首页' }, { link: '/about', name: '关于我们' }, { link: '/news', name: '新闻中心' }, { link: '/contact', name: '联系我们' }] },
				{ language: "en", router: [{ link: '', name: 'Home' }, { link: '/about', name: 'About Us' }, { link: '/news', name: 'News' }, { link: '/contact', name: 'Contact' }] },
				{ language: "ja", router: [{ link: '', name: 'ホーム' }, { link: '/about', name: 'サイトマップ' }, { link: '/news', name: 'インフォメーション' }, { link: '/contact', name: 'お問い合わせ' }] }
			],
			router: [],
			languageList: [
				{ name: "中文", key: 'zh' },
				{ name: "English", key: 'en' },
				{ name: "日本語", key: 'ja' }
			],
			currentLanguage: "zh",
			currentRouterUrl: "",
			isMobile: false,
			showRouter: false
		}
	},
	mounted() {
		//this.currentLanguage=this.$route.params.lang

		this.getRouterLanguage()
		this.setLanguage()
		this.getBackgroudColor()
		console.log(this.$route.path)
	},
	methods: {
		setLanguage() {
			this.$cookies.set('language', this.currentLanguage);
			if (window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
				this.isMobile = true
			}
			this.getRouterLanguage()
			// console.log(this.$route.path)
			// this.$router.push(`/${this.currentLanguage}`)

			if (this.$route.path === '/') {
				this.$router.push(this.currentLanguage)
			} else {
				let url = this.$route.path.split('/')[1]
				let index = ['zh', 'en', 'ja'].find(v => url.includes(v))
				console.log(url, index, 'ff')
				console.log(this.$route.path, 'ff1')
				if (!index) {
					if (this.isMobile) {
						this.$router.push({ path: `${this.$route.path}`, query: this.$route.query })
					} else {
						this.$router.push({ path: `/${url}/${this.currentLanguage}`, query: this.$route.query })

					}

				} else { // 首页
					if(this.isMobile){
						this.$router.push({ path: `${this.$route.path}`, query: this.$route.query })
					}else {
						this.$router.push({ path: `/${this.currentLanguage}`, query: this.$route.query })
					}
				}

			}
		},
		async getBackgroudColor() {
			const res = await this.$http.post('/backgroundConfig')
			if (res.status === 200) {
				if (res.data.length !== 0) {
					localStorage.setItem('backgroudColor', JSON.stringify(res.data[0]))
				}
			}
		},
		goHome() {
			this.$router.push("/" + this.currentLanguage)
		},
		getRouterLanguage() {
			if (this.$cookies.get('language')) {
				this.currentLanguage = this.$cookies.get('language')
			}
			this.routers.forEach(function (router) {
				if (this.currentLanguage == router.language) {
					this.router = router.router
				}
			}.bind(this))
			this.showRouter = true
		},
		getLink(url) {
			this.currentRouterUrl = url;
		},
	}
}
</script>
<style> .public-header {
 	position: absolute;
 	background: rgba(0, 0, 0, 0.6);
 	top: 0;
 	left: 0;
 	right: 0;
 	z-index: 5;
 	width: 100%;
 	height: 100px;
 }

 .public-header .logo-bd {
 	width: 286px;
 	height: 93px;
 	margin-top: 6px;
 }

 .public-header .logo-bd img {
 	width: 100%;
 }

 .public-header .language-bd ul li {
 	color: whitesmoke;
 	line-height: 20px;
 	padding: 0 10px;
 	font-weight: 600;
 	margin-left: 36px;
 	cursor: pointer;
 	text-align: center;
 }

 .public-header .language-bd ul li:hover {
 	padding: 3px 13px;
 	text-align: center;
 	background: #d5dfec;
 	color: #0070b7;
 }

 .public-header .language-bd ggul li.on {
 	color: #0070b7;
 	background: #d5dfec;
 }

 .public-header .nav-c {
 	margin-top: 50px;
 }

 .public-header .nav-c a {
 	float: left;
 	font-weight: 600;
 	font-size: 18px;
 	color: whitesmoke;
 	padding: 0px 14px 0 46px;
 	display: block;
 }

 .public-header .language-bd {
 	margin-top: 10px;
 }
</style>


